import { FormGrid } from '@/lib/features/Assets/components/AddAssetModal/AddAssetModal.styles'
import { SelectTypeControl } from '@/lib/features/Assets/components/AddAssetModal/components'

export const SelectTypeForm = () => (
  <FormGrid>
    <SelectTypeControl />
  </FormGrid>
)
